import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Topbar from "./Navigations/Topbar";
import Footer from "../Footer";
import { sendEmailForContactUs } from "../../service/mailService";
import { useToast } from "../toast/ToastProvider";
import { getCartProductsByCustomerId } from "../../service/CartService";
import { getWishlistProductsByCustomerId } from "../../service/WishlistService";
import { useSelector } from "react-redux";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const toast = useToast();
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);

  const fetchData = async () => {
    const cartData = await getCartProductsByCustomerId(authUser.id);
    const response = await getWishlistProductsByCustomerId(authUser.id);
    setCart(cartData)
    setWishlist(response);
  }

  useEffect(() => {
    fetchData();
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await sendEmailForContactUs(formData);
      if (res.success) {
        toast("We have received your email. We'll reach you back soon.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
      } else {
        toast(res.message || "Failed to send email.", "ERROR");
      }
    } catch (err) {
      console.error("Submission error:", err);
      toast("Could not send the email. Please try again.", "ERROR");
    }
  };

  return (
    <>
      <header className="header style7">
        <Topbar />
      </header>

      <div style={{ background: "#fafafa", minHeight: "100vh" }}>
        <div className="container">
          {/* Breadcrumb */}
          <div className="row pt-4 pb-2">
            <div className="col-lg-12">
              <div className="breadcrumb-trail breadcrumbs">
                <ul className="trail-items breadcrumb">
                  <li className="trail-item trail-begin">
                    <a href="/" className="text-decoration-none">
                      Home
                    </a>
                  </li>
                  <li className="trail-item trail-end active">Contact Us</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Title */}
          <div className="row text-center">
            <h2
              style={{
                fontWeight: "700",
                fontSize: "32px",
                marginBottom: "20px",
                color: "#333",
              }}
            >
              Get in Touch With Us
            </h2>
            <p style={{ color: "#666", maxWidth: "700px", margin: "0 auto 40px",fontSize:'20px' }}>
              Have a question or need assistance? Fill out the form below and our
              team will get back to you shortly.
            </p>
          </div>

          {/* Main Row */}
          <div className="row">
            {/* Contact Form */}
            <div className="col-lg-8 mb-4">
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "30px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  transition: "transform 0.3s ease",
                }}
              >
                <h3 style={{ marginBottom: "20px", fontWeight: "600" }}>
                  Send Us a Message
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 mb-3">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name *"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{
                          width: "100%",
                          padding: "12px 14px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          outline: "none",
                          transition: "all 0.3s ease",
                          fontSize:'16px'
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1px solid #ff4c60")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1px solid #ddd")
                        }
                      />
                    </div>
                    <div className="col-sm-6 mb-3">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email *"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                          width: "100%",
                          padding: "12px 14px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          outline: "none",
                          transition: "all 0.3s ease",
                          fontSize:'16px'
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1px solid #ff4c60")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1px solid #ddd")
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 mb-3">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "12px 14px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          outline: "none",
                          transition: "all 0.3s ease",
                          fontSize:'16px'
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1px solid #ff4c60")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1px solid #ddd")
                        }
                      />
                    </div>
                    <div className="col-sm-6 mb-3">
                      <input
                        type="text"
                        name="company"
                        placeholder="Company"
                        value={formData.company}
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "12px 14px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          outline: "none",
                          transition: "all 0.3s ease",
                          fontSize:'16px'
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1px solid #ff4c60")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1px solid #ddd")
                        }
                      />
                    </div>
                  </div>

                  <textarea
                    name="message"
                    placeholder="Your Message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      outline: "none",
                      transition: "all 0.3s ease",
                      resize: "none",
                      marginBottom: "20px",
                      fontSize:'16px'
                    }}
                    onFocus={(e) =>
                      (e.target.style.border = "1px solid #ff4c60")
                    }
                    onBlur={(e) =>
                      (e.target.style.border = "1px solid #ddd")
                    }
                  />

                  <button
                    type="submit"
                    style={{
                      background: "#ff4c60",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      fontWeight: "600",
                      fontSize: "16px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.background = "#e04355")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.background = "#ff4c60")
                    }
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4">
              <div
                style={{
                  background: "white",
                  borderRadius: "16px",
                  padding: "30px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                }}
              >
                <h3 style={{ marginBottom: "20px", fontWeight: "600",fontSize:'20px' }}>
                  Contact Information
                </h3>
                <p style={{ marginBottom: "15px", color: "#666",fontSize:'15px' }}>
                  Reach us through the following channels:
                </p>
                <div style={{ marginBottom: "15px",fontSize:'12px' }}>
                  <strong className="fs-4">Address:</strong> <br />
                  Restfield White City London G12 Ariel Way - United Kingdom
                </div>
                <div style={{ marginBottom: "15px" ,fontSize:'12px' }}>
                  <strong className="fs-4">Phone:</strong> <br /> (+91) 98422 51585
                </div>
                <div style={{ marginBottom: "15px" ,fontSize:'12px'}}>
                  <strong className="fs-4">Email:</strong> <br /> info@uniquejewellers.co.in
                </div>

                {/* Socials */}
                <div style={{ display: "flex", gap: "15px", marginTop: "20px" }}>
                  <Link
                    to="#"
                    style={{
                      fontSize: "22px",
                      color: "#3b5998",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#2d4373")}
                    onMouseLeave={(e) => (e.target.style.color = "#3b5998")}
                  >
                    <i className="ph ph-facebook-logo"></i>
                  </Link>
                  <Link
                    to="#"
                    style={{
                      fontSize: "22px",
                      color: "#1da1f2",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#0d95e8")}
                    onMouseLeave={(e) => (e.target.style.color = "#1da1f2")}
                  >
                    <i className="ph ph-twitter-logo"></i>
                  </Link>
                  <Link
                    to="#"
                    style={{
                      fontSize: "22px",
                      color: "#e4405f",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#c32f50")}
                    onMouseLeave={(e) => (e.target.style.color = "#e4405f")}
                  >
                    <i className="ph ph-instagram-logo"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{wishlist.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
               <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactUs;
